import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const api = new AxiosInterceptor();

export default {
  find(id) {
    return api.get("/payment_method/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return api.get("/payment_method?" + qstr);
  },
  delete(id) {
    return api.delete("/payment_method/" + id);
  },
  create(inputs) {
    return api.post("/payment_method", inputs);
  },
  update(id, inputs) {
    return api.put("/payment_method/" + id, inputs);
  },
  cancelTesting(id, external_id) {
    return api.put(`/payment_method/${id}/cancel-testing/${external_id}`);
  },
};
